<template>
  <div class="card-footer">
    <div class="d-flex justify-content-between align-items-center">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        @click="goToPrevious"
        :disabled="currentStep === 1"
      >
        <font-awesome-icon icon="chevron-left" class="me-1" />
        <span class="d-none d-sm-inline">Zurück</span>
      </button>

      <div class="d-flex gap-1 gap-sm-2">
        <router-link to="/receipts" class="btn btn-outline-danger btn-sm">
          <span class="d-none d-sm-inline">Abbrechen</span>
          <span class="d-sm-none">✕</span>
        </router-link>

        <button
          v-if="currentStep < totalSteps"
          type="button"
          class="btn btn-primary btn-sm"
          @click="goToNext"
          :disabled="!canProceed || nextStepLoading"
          :title="nextButtonTooltip"
        >
          <span
            v-if="nextStepLoading"
            class="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          <span v-else class="d-none d-sm-inline">Weiter</span>
          <span v-if="!nextStepLoading" class="d-sm-none">→</span>
          <font-awesome-icon
            v-if="!nextStepLoading"
            icon="chevron-right"
            class="ms-1 d-none d-sm-inline"
          />
        </button>

        <template v-else>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="openPreview"
            :disabled="previewing || !canCreateReceipt"
          >
            <span
              v-if="previewing"
              class="spinner-border spinner-border-sm me-2"
              role="status"
            ></span>
            <font-awesome-icon v-else icon="eye" class="me-1" />
            <span class="d-none d-sm-inline">Vorschau</span>
            <span class="d-sm-none">Vorschau</span>
          </button>

          <button
            type="button"
            class="btn btn-success btn-sm"
            @click="createReceiptAction"
            :disabled="!canCreateReceipt || creating || previewing"
          >
            <span
              v-if="creating"
              class="spinner-border spinner-border-sm me-2"
              role="status"
            ></span>
            <font-awesome-icon v-else icon="check" class="me-1" />
            <span class="d-none d-sm-inline">{{ documentLabel }} erstellen</span>
            <span class="d-sm-none">Erstellen</span>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { ReceiptWizardSymbol } from '../tokens'

const wizard = inject(ReceiptWizardSymbol)

if (!wizard) {
  throw new Error('WizardFooter requires ReceiptWizard context')
}

const currentStep = wizard.currentStep
const totalSteps = wizard.totalSteps
const canProceed = wizard.canProceed
const nextStepLoading = wizard.nextStepLoading
const nextButtonTooltip = wizard.nextButtonTooltip
const canCreateReceipt = wizard.canCreateReceipt
const creating = wizard.creating
const previewing = wizard.previewing
const documentLabel = wizard.documentLabel

const goToPrevious = () => wizard.previousStep()
const goToNext = () => wizard.handleNextStep()
const openPreview = () => wizard.previewReceipt()
const createReceiptAction = () => wizard.createReceipt()
</script>
